function browserNavigationIsReload(): boolean {
  const [navigationEntry] = window.performance.getEntriesByType("navigation");

  return (
    navigationEntry !== undefined && "type" in navigationEntry && navigationEntry.type === "reload"
  );
}

function isImportShowPath(pathname: string): boolean {
  return /^\/import\/[^/]+\/?$/u.test(pathname);
}

function isHistoryState(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function clearReloadedImportScrollPosition(): void {
  if (!browserNavigationIsReload() || !isImportShowPath(window.location.pathname)) {
    return;
  }

  const historyState: unknown = window.history.state;

  if (
    !isHistoryState(historyState) ||
    !Object.hasOwn(historyState, "page") ||
    !Array.isArray(historyState["scrollRegions"])
  ) {
    return;
  }

  window.history.replaceState(
    {
      ...historyState,
      scrollRegions: [],
    },
    "",
  );
}
